import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-appsbanner",
  "use": "icon-soc-m-appsbanner-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-appsbanner\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"180\" cy=\"280\" r=\"28\" /><rect x=\"160\" y=\"288\" width=\"704\" height=\"448\" rx=\"32\" /><path d=\"M288 416h448v48H288zM288 528h320v48H288z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-appsbanner.svg
// module id = 9+z1
// module chunks = 491